import React, { useState } from 'react';
import Masonry from 'react-masonry-css';
import Image from './components/images';
import './App.css';
import ImageLoader from './components/api';
import { saveAs } from 'file-saver';

function App() {
  const [query, setQuery] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [images, setImages] = useState([]);
  const imagesPerPage = 20;

  const handleImagesLoaded = (loadedImages, total) => {
    setImages(loadedImages);
    setTotalPages(total);
  };

  const handleDownloadImage = (imageUrl, imageName) => {
    fetch(imageUrl)
      .then((response) => response.blob())
      .then((blob) => {
        saveAs(blob, imageName);
      });
  };

  const breakpointColumnsObj = {
    default: 3,
    1100: 3,
    700: 2,
    500: 1,
  };

  const handleNextPage = () => {
    if (page < totalPages) {
      setPage(page + 1);
      window.scrollTo(0, 0);
    }
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      setPage(page - 1);
      window.scrollTo(0, 0);
    }
  };

  const handleSearch = () => {
    setSearchQuery(query);
    setPage(1);
  };

  const handleInputKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="App">
      <div className="header">
        <div className='title'>
          <p className='title-text' onClick={() =>
            window.location.reload()}>Nova.img</p>
        </div>
        <div className='search-container'>
          <input
            className="seeek"
            type="text"
            placeholder='Search for Images'
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            onKeyPress={handleInputKeyPress}
          />
          <button className="Buttons" onClick={handleSearch}>
            Search
          </button>
        </div>
      </div>

      <div className="container">
        <ImageLoader searchQuery={searchQuery} page={page} imagesPerPage={imagesPerPage} onImagesLoaded={handleImagesLoaded} />
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column">
          {images.map((img, key) => (
            <div className='tuto' key={key}>
              <div className='photo-info'>
                <Image src={img.urls.thumb} alt={img.description || img.alt_description} />
                <p>{img.description || img.alt_description}</p>
              </div>
              <div className='infos'>
                <div className="user-info">
                  <img className="user-profile" src={img.user.profile_image.small} alt={`Profile of ${img.user.name}`} />
                  <p className="user-name">{img.user.name}</p>
                </div>
                <p>Likes: {img.likes}</p>
                <button className="Buttons" onClick={() => handleDownloadImage(img.urls.raw, `${img.id}.jpg`)}>
                  Download
                </button>
              </div>
            </div>
          ))}
        </Masonry>
        <div className="pagination">
          {page > 1 && (
            <button className="Buttons" onClick={handlePreviousPage}>Previous</button>
          )}
          {page < totalPages && (
            <button className="Buttons" onClick={handleNextPage}>Next</button>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
